module.exports = __webpack_public_path__ + "static/img/logo.66faa42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nexa/logo.png
// module id = ekYc
// module chunks = 1